import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { TemplateEmail } from "../../models/template-email/template-email";
import { TemplateEmailCreate } from "../../models/template-email/template-email.create";
import { TemplateEmailLoad } from "../../models/template-email/template-email.load";
import { TemplateEmailUpdate } from "../../models/template-email/template-email.update";

@Injectable()
export abstract class TemplateEmailBackend {
  abstract list(): Observable<TemplateEmail[]>;
  abstract load(request: TemplateEmailLoad): Observable<TemplateEmail>;
  abstract create(request: TemplateEmailCreate): Observable<string>;
  abstract update(request: TemplateEmailUpdate): Observable<void>;
  abstract loadTypes(): Observable<string[]>;
}
